(function () {

    var browserLang = {};
    var siteLang = {};
    var defaultLang = false;

    var options = {
        siteLang: '',
        holder: '',
        langs: [],
        delay: 1000,
        baseLang: ''
    };

    var translations = {"cz":{"name":"Česká verze","txt":"Přepnout do Česky","txt2":"Pokračujeme Česky","txt3":"Vítejte!","welcome":"Vítejte!"},"de":{"name":"Deutsche Version","txt":"auf Deutsch umschalten","txt2":"weiterhin in Deutsch","txt3":"Sprechen Sie Deutsch?","welcome":"Willkommen!"},"en":{"name":"English version","txt":"Switch to english","txt2":"Continue in english","txt3":"Is your language English ?","welcome":"Welcome!"},"es":{"name":"Versión española","txt":"Cambiar a español","txt2":"Continua en español","txt3":"?Hablas español ? ","welcome":"Bienvenido!"},"fr":{"name":"Version française","txt":"Passer au français","txt2":"Continuer en français","txt3":"Continuer en français","welcome":"Bienvenue!"},"global":{"name":"{lang} version","txt":"Switch to {lang}","txt2":"Continue in {lang}","txt3":"Continue in {lang}","welcome":""},"it":{"name":"Versione italiana","txt":"Cambia in italiano","txt2":"Continua in italiano","txt3":"Parli Italiano?","welcome":"Benvenuti!"},"no":{"name":"Engelsk versjon","txt":"Bytt til engelsk","txt2":"Fortsett på engelsk","welcome":"Velkommen!"},"pl":{"name":"Wersja polska","txt":"Zmień na Polski","txt2":"Kontynuuj w języku polskim","txt3":"Czy Twój język to Polski ? ","welcome":"Witaj!"},"ro":{"name":"Versiunea românească","txt":"Schimbă in Română","txt2":"Continuă în Română","txt3":"Continuă în Română","welcome":"Bine ați venit!"},"ru":{"name":"Русская версия","txt":"Продолжить на русском языке","txt2":"продолжать на русском","txt3":"продолжать на русском","welcome":"добро пожаловать!"},"sk":{"name":"Slovenská verzia","txt":"Prepnúť do slovenčiny","txt2":"Pokračujeme slovenský","txt3":"Pokračujeme slovenský","welcome":"Vitajte!"},"sl":{"name":"Slovenska različica","txt":"Preklopite na slovenski jezik","txt2":"Nadaljujte v slovenščini","txt3":"Ali je vaš jezik slovenski?","welcome":"Dobrodošli!"},"zh":{"name":"英语版","txt":"切换到英语","txt2":"以英语继续","txt3":"您说英语吗？","welcome":"欢迎！"}};

    var template = '<div class="lang-switcher">' +
                        '<div class="lang-switcher__inner">' +
                            '<div class="lang-switcher__header">' +
                                '<span class="lang-switcher__header__message">' +
                                    '<span class="welcome-message__txt"></span>' +
                                '</span>' +
                            '</div>' +
                            '<div class="lang-switcher__button">' +
                                '<a class="switch-language lang-current lang-current--browser" href="#">' +
                                    '<div class="lang-switcher__flag">' +
                                        '<span class="lang-current--browser">' +
                                            '<span class="lang-flag"><i></i></span>' +
                                        '</span>' +
                                        '<span class="lang-current--site">' +
                                            '<span class="lang-flag"><i></i></span>' +
                                        '</span>' +
                                    '</div>' +
                                    '<span class="lang-current__txt"></span>' +
                                '</a>' +
                                 '<a class="switch-language lang-current lang-current--site" href="#">' +
                                    '<div class="lang-switcher__flag">' +
                                        '<span class="lang-current--browser">' +
                                            '<span class="lang-flag"><i></i></span>' +
                                        '</span>' +
                                        '<span class="lang-current--site">' +
                                            '<span class="lang-flag"><i></i></span>' +
                                        '</span>' +
                                    '</div>' +
                                    '<span class="lang-current__txt"></span>' +
                                '</a>' +
                            '</div>' +
                            '<button type="button" class="lang-switcher__close" aria-label="Close" data-dismiss="switcher"></button>' +
                        '</div>' +
                    '</div>';

    var getTranslation = function (lang, trans) {
        var translation = translations[lang['key']];

        if (translation && translation[trans]) {
            return translation[trans];
        } else {
            return translations.global[trans].replace('{lang}', lang['name']);
        }
    };

    var $modal = null;

    var modal = {
        /**
         * Init events
         */
        init: function () {

            if (window.LangTranslations) {
                translations = $.extend({}, translations, LangTranslations);
            }

          

            $modal = $('<div/>', {
                'id': 'lang-switcher',
                'class': 'lang-switcher-hld',
                'html': template
            });



            var $langCurrentBrowser = $modal.find('.lang-current--browser');
            var $langCurrentSite = $modal.find('.lang-current--site');
            //var $langListHld = $modal.find('.lang-switcher__list ul');
            var welcome = getTranslation(siteLang, 'welcome') + ' ';

            /**
             * If current browsers language
             * is not available on site
             * show english as default switch
             *
             * Else -> show 'continue in current browsers language'
             *
             */
            if (!browserLang.name) {

                if (defaultLang) {
                    $langCurrentBrowser.remove();

                    $langCurrentSite.find('.lang-current__name').html(getTranslation(defaultLang, 'name'));
                    $langCurrentSite.find('.lang-current__txt').html(getTranslation(defaultLang, 'txt'));
                    $langCurrentSite.find('.lang-flag i').addClass(defaultLang.key);
                    $langCurrentSite.attr('href', defaultLang.url);
                    $langCurrentSite.on('click', function (e) {
                        createCookie('lang', defaultLang.key, 1);
                    });

                    $modal.find('.lang-switcher__header__title').html(getTranslation(defaultLang, 'welcome'));
                    $modal.find('.welcome-message__txt').html(getTranslation(defaultLang, 'txt3'));

                } else {
                    $modal.find('.lang-switcher__current').remove();
                }
            } else {
                $langCurrentSite.remove();
                $langCurrentBrowser.find('.lang-current__name').html(getTranslation(browserLang, 'name'));
                $langCurrentBrowser.find('.lang-current__txt').html(getTranslation(browserLang, 'txt'));
                $langCurrentBrowser.find('.lang-flag i').addClass(browserLang.key);
                $langCurrentBrowser.attr('href', browserLang.url);
                $langCurrentBrowser.on('click', function (e) {
                    createCookie('lang', browserLang.key, 1);
                });

                $modal.find('.lang-switcher__header__title').html(getTranslation(browserLang, 'welcome'));
                $modal.find('.welcome-message__txt').html(getTranslation(browserLang, 'txt3'));
            }


            $modal.find('.lang-switcher__header__txt').html(welcome);
            
            /*
             * HOOK PREPARATION
             */

            var holder = $(options.holder);

            if (holder.length > 0) {
                $modal.prependTo(holder);
                $modal.addClass('hooked-in-element');
                $('body').addClass('lang-switcher-in-element');

            } else {
                $modal.prependTo('body');
                $modal.addClass('hooked-in-body');
                $('body').addClass('lang-switcher-in-body');
            }

            // Close modal clicking in button X
            $('.lang-switcher__close').on('click', function (e) {
                modal.hide();
                createCookie('closeBtn-lang', siteLang['key']);
            })

            // Close modal clicking in bg
            $('body').on('click', '.lang-switcher-hld', function (e) {});

            $(document).trigger('langstart-initialized');

            // Show modal
            modal.show();
        },
        //END OF init: function
        show: function () {
            $modal.show(0).addClass('active');
        },
        hide: function () {
            $modal.removeClass('active');

            setTimeout(function () {
                $modal.hide(0);
                $(document).trigger('langstart-closed');
            }, 300);
        }
    };

    var checkLang = function (language) {

        if (readCookie('closeBtn-lang') == null) {
            if (language.key !== options.siteLang) {
                if (readCookie('lang') !== options.siteLang) {
                    modal.init();
                }

            }
        }
    };

    var getLang = function () {
       
        return browserLang;

    };

    var init = function (settings) {    
        options = $.extend({}, options, settings);

        if (window.LangOptions) {
            options = $.extend({}, options, window.LangOptions);
        }
       
        siteLang = {
            key: options.siteLang,
            url: '',
            name: ''
        };

       

        var lang = window.navigator.languages ? window.navigator.languages[0] : null;
        lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;

        if (lang.indexOf('-') !== -1) {
            lang = lang.split('-')[0];
        }

        if (lang.indexOf('_') !== -1) {
            lang = lang.split('_')[0];
        }

        
        browserLang = {
            key: lang,
            url: '',
            name: ''
        };

        

        $.each(options.langs, function (i, lang) {
            if (lang.key == browserLang.key) {
                browserLang.url = lang.url;
                browserLang.name = lang.name;
            }

            if (lang.key == siteLang.key) {
                siteLang.name = lang.name;
            }

            if (lang.key == 'en') {
                defaultLang = lang;
            }

            if (lang.key == options.baseLang) {
                defaultLang = lang;
            }
        });

       
       

        if (!browserLang.name) {
            options.langs = options.langs.filter(function (el) {
               
                return (el.key !== options.siteLang && el.key !== 'en');
               
            });
        } else {
            options.langs = options.langs.filter(function (el) {
                return (el.key !== browserLang.key) && (el.key !== options.siteLang);
            });
        }

        setTimeout(function () {
            checkLang(browserLang);
        }, options.delay);

    }



    var api = {
        init: init,
        getLang: getLang,
        modal: modal
    };

    /**
     * Expose as a global
     */

    window.Lang = api;

    /**
     * Cookies helper functions
     */



    // Create cookie
    function createCookie(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";

    }



    // Read cookie
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

})();
